import React from "react";


const PasswordactiveIcon = props => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_220" data-name="Rectangle 220" width="22.404" height="18.828" transform="translate(0 0)" fill="none" stroke="#777" stroke-width="1"/>
    </clipPath>
  </defs>
  <g id="Group_691" data-name="Group 691" transform="translate(-1000.202 -594.414)">
    <rect id="Rectangle_222" data-name="Rectangle 222" width="24" height="24" transform="translate(1000.202 594.414)" fill="none"/>
    <g id="Group_687" data-name="Group 687" transform="translate(1001 597)" clip-path="url(#clip-path)">
      <path id="Path_407" data-name="Path 407" d="M1.2,10.414s4-6,10-6,10,6,10,6-4,6-10,6S1.2,10.414,1.2,10.414Z" fill="none" stroke="#777" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"/>
      <circle id="Ellipse_32" data-name="Ellipse 32" cx="4" cy="4" r="4" transform="translate(7.202 4.414)" fill="none" stroke="#777" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"/>
    </g>
  </g>
</svg>

    );

}

export default PasswordactiveIcon;